module.exports = __webpack_public_path__ + "static/media/image.19180116.svg";